import React, { useEffect, useState } from 'react';

const Loader = () => {
    const [currState, setCurrState] = useState(0);
    const [loading, setLoading] = useState(true);
    const loadTime = 1000;
    // const [percentage, setPercentage] = useState(0);

    
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrState((currState + 1) % 4);
        }, 100);
        return () => {clearInterval(interval)};
    }, [currState]);
    
    useEffect(() => {
        const updateClassNames = () => {
            for (let i = 1; i <= 4; i++) {
                const c = `c${i}`;
                const f = `f${i}`;
                if (currState === i-1) {
                    document.getElementsByClassName(c)[0].setAttribute('fill', '#FFFA86');
                    document.getElementsByClassName(f)[0].setAttribute('filter', `url(#filter${currState}_f_100_313)`);
                } else {
                    document.getElementsByClassName(c)[0].setAttribute('fill', '#DBDDCC');
                    document.getElementsByClassName(f)[0].removeAttribute('filter');
                }
            }
        };
        if (loading) {updateClassNames();}
    }, [currState, loading]);
  

    useEffect(() => {
        function turnOffLoader(){
            if (loading){
                setLoading(false);
                const load = document.getElementById('load');
                console.log('turn off loader');
                document.getElementById("rocket").classList.add('animate-fly');
                load.classList.add('animate-fade-out');
                setTimeout(() => {
                    load.classList.add('hidden');
                }, 1500);
            }
        };
        if (loading) {setTimeout(() => turnOffLoader(), loadTime);}
    }, [loading]);

    return (
        <div className="fixed top-0 left-0 z-[100] w-screen flex justify-center items-center h-screen bg-gradient-to-tr from-[#7083AB] to-blue-300" id='load'>
            <div className="rounded-full h-fit w-fit border-gray-900 animate-small-bounce" id='rocket'>
                <svg width="139" height="307" viewBox="0 0 372 820" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M251.861 546.959L120.064 546C85.5566 635.623 111.53 720.591 185.722 819.183C259.913 720.591 286.368 636.582 251.861 546.959Z" fill="#FF5C28"/>
                <path d="M237.951 546.713L134.121 546C106.936 612.667 127.398 675.871 185.846 749.21C244.295 675.871 265.135 613.38 237.951 546.713Z" fill="#FF9C28"/>
                <path d="M225.123 539.512L146.936 539C126.466 586.898 141.874 632.308 185.887 685C229.9 632.308 245.594 587.411 225.123 539.512Z" fill="#FFCD4D"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M186 534H107.259C105.424 534 103.713 532.955 102.849 531.337C-27.1581 287.947 123.885 75.2493 178 6.49999C180.352 3.51138 182.516 1.77127 184.503 1.17712C184.99 1.01934 185.489 0.94108 186.001 0.944342C186.512 0.941212 187.01 1.01941 187.497 1.17693C189.484 1.77092 191.647 3.51108 194 6.49999C248.115 75.2493 399.159 287.947 269.152 531.337C268.288 532.955 266.577 534 264.742 534H186Z" fill="#A7C1D3"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M185.517 549L185.516 548.994L185.516 549H120.75C118.784 549 116.982 547.812 116.185 546.015C114.404 542.001 112.687 537.996 111.032 534L260.001 534C258.346 537.996 256.629 542.001 254.848 546.015C254.051 547.812 252.249 549 250.283 549H185.517Z" fill="#272727"/>
                <circle cx="186" cy="204" r="66" fill="#4B5776"/>
                <circle cx="186" cy="204" r="57" fill="#D3FDFA" id="progress"/>
                <path d="M31.5785 575.266C-4.67358 528.786 4.44588 401.044 52.3353 328.65C57.4715 403.268 65.6785 443.725 93.5 512.5C63.8865 533.426 49.3679 548.344 31.5785 575.266Z" fill="#1C2333"/>
                <path d="M340.341 575.378C376.594 528.899 367.474 401.157 319.585 328.763C314.448 403.381 306.241 443.838 278.42 512.613C308.033 533.539 322.552 548.457 340.341 575.378Z" fill="#1C2333"/>
                <path d="M185.826 329C210.824 332 208.315 487.5 185.819 580.5C163.323 487.5 160.828 332 185.826 329Z" fill="#1C2333"/>
                <g className="f1" filter="url(#filter0_f_100_313)">
                <circle className="c1" cx="118.5" cy="303.5" r="12.5" fill="#FFFA86"/>
                </g>
                <g className="f2" filter="url(#filter1_f_100_313)">
                <circle className="c2" cx="163.5" cy="303.5" r="12.5" fill="#FFFA86"/>
                </g>
                <g className="f3" filter="url(#filter2_f_100_313)">
                <circle className="c3" cx="208.5" cy="303.5" r="12.5" fill="#FFFA86"/>
                </g>
                <g className="f4" filter="url(#filter3_f_100_313)">
                <circle className="c4" cx="253.5" cy="303.5" r="12.5" fill="#FFFA86"/>
                </g>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M245.5 81H126.501C145.778 48.6776 164.781 23.294 178 6.49999C180.353 3.51138 182.516 1.77127 184.503 1.17712C184.99 1.01934 185.489 0.94108 186.001 0.944342C186.512 0.941212 187.011 1.01941 187.497 1.17693C189.484 1.77092 191.648 3.51108 194 6.49999C207.219 23.294 226.222 48.6776 245.5 81Z" fill="#1C2333"/>
                <defs>
                <filter id="filter0_f_100_313" x="103.2" y="288.2" width="30.6" height="30.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="1.4" result="effect1_foregroundBlur_100_313"/>
                </filter>
                <filter id="filter1_f_100_313" x="148.2" y="288.2" width="30.6" height="30.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="1.4" result="effect1_foregroundBlur_100_313"/>
                </filter>
                <filter id="filter2_f_100_313" x="193.2" y="288.2" width="30.6" height="30.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="1.4" result="effect1_foregroundBlur_100_313"/>
                </filter>
                <filter id="filter3_f_100_313" x="238.2" y="288.2" width="30.6" height="30.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="1.4" result="effect1_foregroundBlur_100_313"/>
                </filter>
                </defs>
                </svg>

            </div>
        </div>
    );
};

export default Loader;
